<template>
    <a class="result-item" :href="item.resource_url" tabindex="0">
    <div class="item-box" :style="{ backgroundImage: type === 'video' ? `url(${baseUrl}/images/placeholder-video-small.png)` : `url(${baseUrl}/images/placeholder.jpg)`}">
        <div class="image" :style="{ backgroundImage: `url(${image})`}"></div>
        <div v-if="type === 'video'" class="play-btn">
          <img :src="`${baseUrl}/images/play-icon.svg`" />
        </div>
        <div class="title-wrapper p-3">
            <h4 class="title">{{ itemTitle }}</h4>
        </div>
    </div>
    </a>
</template>

<script>
import { calculateXYZ, getImageUrlForKey } from '../../helpers'

export default {
  props: ['item', 'type'],
  data: () => ({
    baseUrl: process.env.MIX_ASSET_URL,
    thumb: null
  }),
  mounted () {
    // console.log(this.item, this.type)
  },
  computed: {
    image: function () {
      switch (this.type) {
        case 'image':
        case 'images':
          return getImageUrlForKey(_.get(this.item, 'path'), 1140, 600)
        case 'video':
        case 'videos':
          return getImageUrlForKey(_.get(this.item, 'thumbnail_url'), 1140, 600)
        case 'location':
        case 'locations':
          return calculateXYZ(this.item.latitude, this.item.longitude)
        case 'byggnadsInventering':
          return this.item.image_url
        default:
          return getImageUrlForKey(_.get(this.item, 'images[0].path'), 1140, 600)
      }
    },
    itemTitle: function () {
      switch (this.type) {
        case 'audio':
          return `Ljud: ${this.item.title}`
        case 'audio-walks':
          return `Ljudvandring: ${this.item.title}`
        default:
          return this.item.title
      }
    }
    // typeString: function () {
    //   switch (this.type) {
    //     case 'article':
    //       return '/artikel/'
    //     case 'location':
    //       return '/plats/'
    //     case 'image':
    //       return '/bild/'
    //     case 'video':
    //       return '/film/'
    //     case 'document':
    //       return '/dokument/'
    //     default:
    //       return '#'
    //   }
    // },
    // linkHref: function () {
    //   return getLinkHref(`${this.typeString}${this.item.id}`)
    // }
  }
}
</script>
